import React from 'react'
import './AgeStats.css'

function AgeStats (props) {
  return (
    <div className="age-stats">
      <span>{props.read} read</span>
      <span>{props.unread} unread</span>
    </div>
  );
};

export default AgeStats;